// extracted by mini-css-extract-plugin
module.exports = {"container":"MainProjectCard_container__yoQzB","address":"MainProjectCard_address__wPxr8"};